import { FC } from 'react'
import { useToggle } from 'react-use'
import AddButton from '@organisms/AddButton'
import Modal from '@organisms/Modal'
import ChapterFormModal from '@modals/ChapterFormModal'

type Props = {
  courseIri: string
}

const AddChapterButton: FC<Props> = ({ courseIri }) => {
  const [visible, toggleVisible] = useToggle(false)

  return (
    <>
      <AddButton onClick={toggleVisible}>Добавить раздел</AddButton>
      <Modal visible={visible} onModalClose={toggleVisible}>
        <ChapterFormModal
          isEdit={false}
          courseIri={courseIri}
          handleCloseModal={toggleVisible}
        />
      </Modal>
    </>
  )
}

export default AddChapterButton
